import {MaritalStatus} from '../../services/schemas/loanServiceSchemas/maritalStatus';

// Regimes retain the existing marital-status storage contract; no guessed property regime.
export const marriageRegimes = [
  {value:MaritalStatus.MARRIED_UNKNOWN,label:'Unknown'},
  {value:MaritalStatus.IN_COMMUNITY_OF_PROPERTY,label:'Marriage In Community of Property'},
  {value:MaritalStatus.OUT_OF_COMMUNITY_OF_PROPERTY,label:'Marriage Out of Community of Property'},
  {value:MaritalStatus.TRADITIONAL_CUSTOMARY,label:'Traditional / Custom'}
];
export function maritalCategory(value?: string) {
  if (value === 'MARRIED' || marriageRegimes.some(regime=>regime.value===value)) return 'MARRIED';
  return ['UNKNOWN','SINGLE','DIVORCED','WIDOWED'].includes(value || '') ? value! : '';
}
export function maritalStatusError(value: unknown) {
  if(value === 'MARRIED') return 'Select a marital regime for the married applicant.';
  if(!Object.values(MaritalStatus).includes(value as MaritalStatus)) return 'Select a marital status.';
  return undefined;
}
